// src/components/layout/AuthLayout.tsx
import React, { Children } from 'react';
import { Outlet } from 'react-router-dom';
import Logo from '../common/Logo';
import MainNavigation from '../common/MainNavigation';

interface AuthLayoutProps {
  children?: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const isMobile = window.innerWidth < 960;

  return (
    <div className="auth-layout">
      {/* Main Navigation */}
      <MainNavigation variant="solid" />
      
      <div className="auth-layout__container">
        {/* Logo section */}
        <div className="auth-layout__logo">
          <Logo />
        </div>

        <div className="auth-layout__content">
          {/* Marketing content at the top (hidden on mobile) */}
          {!isMobile && (
            <div className="auth-layout__marketing">
              <div className="auth-layout__decorative-element"></div>
              <h1 className="auth-layout__title">LookBel: <span className="accent-text">Beauty Appointments Made Simple</span></h1>
              <p className="auth-layout__subtitle">
                Connect with top professionals for hair, makeup, nails, and more.
                Book appointments easily and manage your beauty services all in one place.
              </p>
              <div className="auth-layout__decorative-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
          )}

          {/* Right side - auth form */}
          <div className="auth-layout__form">
            {children || <Outlet />}
            
            {/* Welcome message if on home route */}
            {window.location.pathname === '/' && !children && !Children.count(children) && (
              <div className="auth-welcome">
                <h2 className="auth-form__title">Welcome to LookBel</h2>
                <p className="auth-form__subtitle">Your one-stop platform for all beauty services.</p>
                <div className="auth-form__actions">
                  <a href="/login" className="tesla-button tesla-button--primary">Sign In</a>
                  <a href="/register" className="tesla-button tesla-button--outline">Create Account</a>
                </div>
                <a href="/home" className="auth-form__link mt-4 d-block">Explore Our Services</a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;